'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "EmptySwatch", {
    enumerable: true,
    get: function() {
        return EmptySwatch;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useEmptySwatch = require("./useEmptySwatch");
const _renderEmptySwatch = require("./renderEmptySwatch");
const _useEmptySwatchStylesstyles = require("./useEmptySwatchStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const EmptySwatch = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useEmptySwatch.useEmptySwatch_unstable)(props, ref);
    (0, _useEmptySwatchStylesstyles.useEmptySwatchStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useEmptySwatchStyles_unstable')(state);
    return (0, _renderEmptySwatch.renderEmptySwatch_unstable)(state);
});
EmptySwatch.displayName = 'EmptySwatch';
